import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface FeatureConfigHeaderProps {
  title: string;
  onClose: () => void;
  subtitle?: string;
}

export const FeatureConfigHeader: React.FC<FeatureConfigHeaderProps> = ({
  title,
  onClose,
  subtitle
}) => {
  return (
    <div className="flex items-center justify-between p-[1.4rem] border-b border-[#E5E7EB] bg-[#F7F9FC]/85 backdrop-blur-sm sticky top-0 z-10">
      <div>
        <h2 className="text-xl font-semibold text-foreground">{title}</h2>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1">
            {subtitle}
          </p>
        )}
      </div>
      
    </div>
  );
};